import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CategoriesService } from '../_services';
import { fetchWrapper } from '../_helpers';

// create slice

const name = 'categories';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const categoriesActions = { ...slice.actions, ...extraActions };
export const categoriesReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        categories: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/categories`;

    return {
        getAll: getAll(),
        getMain: getMain()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(baseUrl)
        );
    }
    function getMain() {
        return createAsyncThunk(
            `${name}/getMain`,
            async () => await await CategoriesService.getMain()
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll(), ...getMain()    
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.categories = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.categories = action.payload;
            },
            [rejected]: (state, action) => {
                state.categories = { error: action.error };
            }
        };
    }
    function getMain() {
        var { pending, fulfilled, rejected } = extraActions.getMain;
        return {
            [pending]: (state) => {
                state.categories = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.categories = action.payload;
            },
            [rejected]: (state, action) => {
                state.categories = { error: action.error };
            }
        };


    }
}
